<template>
  <div>
    <div class="cnt">
      <div
        class="pdf-container"
        :style="{ width: pdfContainerWidth, height: pdfContainerHeight }"
      >
        <canvas
          id="the-canvas"
          ref="pdfRef"
          @click="canvasClick"
          class="pdf"
        ></canvas>
        <div class="link-layer" ref="linkLayer"></div>
        <progress
          class="bar progress-bar"
          :max="pdfNumPages - 1"
          :value="pageNum - 1"
        ></progress>
        <div>{{ pageNum }} / {{ pdfNumPages }}</div>
        <div class="fullsc-button">
          <button class="c_btn c_eval_submit" @click="showFullScreen">
            Fullscreen
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as pdfjsLib from "pdfjs-dist/legacy/build/pdf";
pdfjsLib.GlobalWorkerOptions.workerSrc = "/pdf.worker.min.js";

let pdfDoc;

export default {
  props: {
    url: {
      type: String,
      required: true
    },
    contents: {
      type: Object,
      required: true,
      default: () => ({})
    }
  },
  data: () => ({
    pageNum: 1,
    pdfNumPages: 1,
    pdfContainerWidth: 1,
    pdfContainerHeight: 1,
    debounceTimer: null
  }),
  watch: {
    pageNum() {
      if (pdfDoc) {
        this.renderPage();
      }
    }
  },
  created() {
    if (this.contents.progress && this.contents.progress.current_position) {
      this.pageNum = this.contents.progress.current_position;
    }
  },
  mounted() {
    this.readPDF();
    window.addEventListener("keydown", this.keyAction);
  },
  beforeDestroy() {
    clearTimeout(this.debounceTimer);
    window.removeEventListener("keydown", this.keyAction);
  },
  methods: {
    async readPDF() {
      const loadingTask = pdfjsLib.getDocument({
        url: this.url,
        withCredentials: true,
        isEvalSupported: false
      });
      pdfDoc = await loadingTask.promise;
      this.pdfNumPages = pdfDoc.numPages;
      this.renderPage();
    },
    //handleResize() {
    //  // 画面サイズ変更時に再描画
    //  if (pdfDoc) this.renderPage();
    //},
    renderPage() {
      if (!pdfDoc) return;

      pdfDoc.getPage(this.pageNum).then(page => {
        const container = this.$el.querySelector(".pdf-container");
        const containerWidth = container.clientWidth; // 画面幅（親要素）
        const viewport = page.getViewport({ scale: 1.0 });
        const scale = containerWidth / viewport.width;

        //const scale = 1.0;
        //const viewport = page.getViewport({ scale });
        const outputScale = window.devicePixelRatio || 1;
        const scaledViewport = page.getViewport({ scale });

        const canvas = document.getElementById("the-canvas");
        const context = canvas.getContext("2d");

        canvas.width = Math.round(scaledViewport.width * outputScale);
        canvas.height = Math.round(scaledViewport.height * outputScale);
        canvas.style.width = `${Math.round(scaledViewport.width)}px`;
        canvas.style.height = `${Math.round(scaledViewport.height)}px`;

        this.pdfContainerWidth = `${scaledViewport.width}px`;
        this.pdfContainerHeight = `${scaledViewport.height}px`;

        //const canvas = document.getElementById("the-canvas");
        //const context = canvas.getContext("2d");

        //canvas.width = Math.floor(viewport.width * outputScale);
        //canvas.height = Math.floor(viewport.height * outputScale);
        //canvas.style.width = Math.floor(viewport.width) + "px";
        //canvas.style.height = Math.floor(viewport.height) + "px";
        //this.pdfContainerWidth = canvas.style.width;
        //this.pdfContainerHeight = canvas.style.height;

        const transform =
          outputScale !== 1 ? [outputScale, 0, 0, outputScale, 0, 0] : null;

        const renderContext = {
          canvasContext: context,
          transform,
          viewport: scaledViewport
        };
        page.render(renderContext);

        this.renderLinks(page, scaledViewport);
      });
    },
    renderLinks(page, viewport) {
      const linkLayer = this.$refs.linkLayer;
      linkLayer.innerHTML = "";

      page.getAnnotations().then(annotations => {
        annotations.forEach(annotation => {
          if (annotation.subtype === "Link" && annotation.url) {
            // ビューポート座標に合わせてリンクの位置を計算
            const bounds = pdfjsLib.Util.normalizeRect(
              viewport.convertToViewportRectangle(annotation.rect)
            );

            const link = document.createElement("a");
            link.href = annotation.url;
            //link.target = "_blank";
            link.target = "_self"; // 別タブではなく、同じウィンドウで動作
            link.setAttribute("download", "");
            link.style.position = "absolute";
            link.style.left = `${bounds[0]}px`;
            link.style.top = `${bounds[1]}px`;
            link.style.width = `${bounds[2] - bounds[0]}px`;
            link.style.height = `${bounds[3] - bounds[1]}px`;
            //link.style.border = "2px solid rgba(255, 0, 0, 0.5)"; // デバッグ用

            linkLayer.appendChild(link);
          }
        });
      });
    },
    canvasClick(evt) {
      // 左半分をクリックしたら１ページ戻る
      // 右半分をクリックしたら１ページ進む
      const offset = this.$refs.pdfRef.getBoundingClientRect();
      const x = evt.clientX - offset.left;
      if (x < offset.width / 2) {
        this.pagePrev();
      } else {
        this.pageNext();
      }
    },
    saveProgress(page, finish) {
      const progressData = {
        current_position: finish ? 0 : page,
        progress_ratio: finish ? 1.0 : page / this.pdfNumPages
      };
      this.$authAxios
        .post(`/api/contents/${this.contents.id}/progress/`, progressData)
        .catch(error => {
          console.error("Error sending progress:", error);
        });
    },
    updatePage(newPage) {
      this.pageNum = newPage;

      // 5秒閲覧したら状態保存
      clearTimeout(this.debounceTimer);
      if (newPage == this.pdfNumPages) {
        this.saveProgress(newPage, 1);
      } else {
        this.debounceTimer = setTimeout(() => {
          this.saveProgress(newPage, 0);
        }, 5000);
      }
    },
    pagePrev() {
      this.updatePage(this.pageNum > 1 ? this.pageNum - 1 : this.pageNum);
    },
    pageNext() {
      this.updatePage(
        this.pageNum < this.pdfNumPages ? this.pageNum + 1 : this.pageNum
      );
    },
    showFullScreen() {
      this.requestFullScreen(this.$refs.pdfRef);
    },
    requestFullScreen(element) {
      if (element.requestFullscreen) {
        element.requestFullscreen();
      } else if (element.mozRequestFullScreen) {
        // Firefox
        element.mozRequestFullScreen();
      } else if (element.webkitRequestFullscreen) {
        // Chrome, Safari and Opera
        element.webkitRequestFullscreen();
      } else if (element.msRequestFullscreen) {
        // IE/Edge
        element.msRequestFullscreen();
      }
    },
    keyAction(e) {
      if (e.keyCode === 37) {
        this.pagePrev();
      } else if (e.keyCode === 39) {
        this.pageNext();
      }
    }
  }
};
</script>

<style scoped>
.cnt {
  display: flex;
  justify-content: center;
  height: 100%;
}
.pdf-container {
  width: 100%;
  user-select: none;
  position: relative;
}

.pdf {
  border: 1px solid black;
  position: relative;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
}

.progress-bar {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  z-index: 3;
}

progress {
  height: 0.5rem;
  -webkit-appearance: none;
  -moz-appearance: none;
  background-color: rgba(0, 0, 0, 0.15);
}
::-webkit-progress-bar {
  background-color: rgba(0, 0, 0, 0.15);
}
::-webkit-progress-value {
  background-color: #009287;
}
::-moz-progress-bar {
  background-color: #009287;
}

.fullsc-button {
  text-align: end;
}

.link-layer {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.link-layer >>> a {
  z-index: 2;
}
</style>
